import { BEDevice, UTILS_DEPENDENCIES, UtilsDependencies, UtilsState } from "@/models/UtilsState";
import { Device, Market } from "../../../models/Common";

const cacheTransforms: { [key: string] : any } = {}

export const UtilsGetters = { 
	GET_DEPENDENCIES: 'GET_DEPENDENCIES',
	GET_DEVICES: 'GET_DEVICES',
	GET_DEVICES_TITLES_MAP: 'GET_DEVICES_TITLES_MAP',
	GET_FAMILY_CATEGORY_MAPPINGS: 'GET_FAMILY_CATEGORY_MAPPINGS',
	GET_MARKETS: 'GET_MARKETS'
}

export default {
	[UtilsGetters.GET_DEPENDENCIES]: (state: UtilsState): UtilsDependencies => {
		return state.data
	},
	[UtilsGetters.GET_DEVICES]: (state: UtilsState): Device[] | null => {
		return state.data[UTILS_DEPENDENCIES.DEVICES];
	},
	[UtilsGetters.GET_DEVICES_TITLES_MAP]: (state: UtilsState): Record<number, string> => {
		return state.data[UTILS_DEPENDENCIES.DEVICES]?.reduce((acc, device: Device) => {
			acc[device.id] = device.title;
			return acc;
		}, {} as any);
	},
	[UtilsGetters.GET_FAMILY_CATEGORY_MAPPINGS]: (state: UtilsState) : Record<number, string> => {
		return getUtilsDep(UtilsGetters.GET_FAMILY_CATEGORY_MAPPINGS, state)
	},
	[UtilsGetters.GET_MARKETS]: (state: UtilsState): Market[] | null => { 
		return getUtilsDep(UtilsGetters.GET_MARKETS, state);
	}
}

const getUtilsDep = (getter: string, state: UtilsState) => { 
	if (cacheTransforms[getter]) {
		return cacheTransforms[getter]
	}

	const transform = transformsStrategies[getter];
	if (typeof transform !== 'function') { 
		return {}
	}

	const map = transform(state.data);
	cacheTransforms[getter] = map
	return cacheTransforms[getter];
}

export const transformsStrategies = {
	[UtilsGetters.GET_FAMILY_CATEGORY_MAPPINGS]: (data: UtilsDependencies) => {
		const map : Record<number, string> = {};
		data[UTILS_DEPENDENCIES.DEVICES]?.forEach((device: Device) => {
			const dev = device as BEDevice;
			if (!map[dev.device_family_category_id]) {
				map[dev.device_family_category_id] = dev.device_family_category
			}
		})
		return map;
	},
	[UtilsGetters.GET_MARKETS]: (data: UtilsDependencies) => {
		const map : Record<number, string> = {};
		data[UTILS_DEPENDENCIES.MARKETS]?.forEach((market: Market) => {
			if (!map[market.id]) {
				map[market.id] = market.title
			}
		})
		return map;
	}
}
